import { useState ,useEffect} from 'react'
import {useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getDms,getUsers } from '../../redux/actions';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import UserSummary from '../UserSummary/UserSummary';
import { LoaderList } from '../UI/Loader/Loader';
import magnifier from "../../img/magnifier.svg"
import './UserList.css';
import { jwtDecode } from 'jwt-decode'; // Добавьте эту библиотеку для декодирования JWT

export default function UserList() {
    const navigate = useNavigate();
    const token = localStorage.getItem('token'); // Предположим, что токен хранится в localStorage
    const [input,setInput] =useState('');
    const dispatch = useDispatch();
    const [isLoading,setIsLoading]=useState(false);
    const role=useSelector((state) => state.userdata?.role);
    const users=useSelector((state) => state.usersdata?.users);
    const dms = useSelector((state) => state.dm?.data);

        // Функция для проверки срока действия токена
    const isTokenExpired = (token) => {
        try {
            const decoded = jwtDecode(token);
            return decoded.exp < Date.now() / 1000;
        } catch (e) {
            return true; // Если токен невалидный, считаем его просроченным
        }
    };

        useEffect(() => {
        // Проверяем токен при каждом рендере
        if (!token || isTokenExpired(token)) {
            localStorage.removeItem('token');
            navigate('/');
            return;
        }
        if (role === 1) {
             } else if (role) {
             navigate('/');
             }
        setIsLoading(true);
       const fetchGetDms = async () => {
            try { await dispatch(getDms());
                await dispatch(getUsers());
               setIsLoading(false);  
            } catch (error) { console.error('Ошибка при получении данных:', error);}
            };
            fetchGetDms();
    }, [role, token, navigate, dispatch]);

    const getUserDms = (userId) => {
        return dms.filter((dm) => dm.id === userId) // создаем список предметов по пользователю
      };

      const filteredListUser = users && users?.filter(user =>
        input === '' || // Если поисковой запрос пуст, отображаем все элементы
         user.username.toLowerCase().includes(input.toLowerCase()) ||
         user.surname.toLowerCase().includes(input.toLowerCase()) ||
         user.name.toLowerCase().includes(input.toLowerCase()) ||
         user.patronymic.toLowerCase().includes(input.toLowerCase())
      );

    return (
        <div className='main-UserList'> 
            <div className='UserListHeader'> 
                <div className='UserListName'> 
                    <h3> Всего пользователей<span>{users?.length}</span></h3> 
                </div>
                <div className='UserListQuest'> 
                    <input type='text' className='UserListInput' placeholder='Введите ФИО или логин пользователя'
                        value={input}
                        onChange={(e)=>setInput(e.target.value)}
                    /> 
                     {input==='' ? (
                  <img src={magnifier} alt="Result" className='UserListQuestImgMag'/>
                  ) : (
                    <svg  onClick={()=>setInput('')} className='UserListQuestDelet' height="30" viewBox="0 0 200 200" width="30">    
                    <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                </svg>
                  )}
                </div>
            </div> 
                {isLoading ? (<LoaderList />) : (
                <div className='UserListMainContent'>
                    <TransitionGroup>
                            {filteredListUser?.map(user=>
                                <CSSTransition
                                    key={user.id}
                                    timeout={500}
                                    classNames='userCard'
                                >
                            <UserSummary key={user.id} user={user} dmUser={getUserDms(user.id)} />
                            </CSSTransition>
                            )}
                    </TransitionGroup>
                </div> 
                )}
        </div>
    )
}